import { gettext } from './state/gettext-extract-util';
class AppSettings {
  constructor() {
    this.environment = process.env.NODE_ENV;
    this.environments = {
      local: 'local',
      staging: 'staging',
      production: 'production',
    };

    const icebergUrl = process.env.ICEBERG_BASE_URL;
    const tugApiUrl = process.env.TUGAPI_BASE_URL;
    const reportingApiUrl = process.env.REPORTING_API_URL;

    this.BaseTugApiUrl = tugApiUrl;
    this.BaseIcebergUrl = icebergUrl;
    this.RepotingApiUrl = reportingApiUrl;

    this.IcebergApiUserInfoEndpoint = `${icebergUrl}/2561`;
    this.IcebergApiTransfersEndpoint = `${icebergUrl}/2049`;
    this.IcebergApiAttributesEndpoint = `${icebergUrl}/4393`;
    this.IcebergApiPackagesEndpoint = `${icebergUrl}/1281`;
    this.IcebergApiInstallationsEndpoint = `${icebergUrl}/769`;
    this.IcebergApiEquipmentEndpoint = `${icebergUrl}/513`;
    this.IcebergApiDevicesEndpoint = `${icebergUrl}/257`;
    this.IcebergApiDatapointsEndpoint = `${icebergUrl}/1281`;
    this.IcebergApiCommandsEndpoint = `${icebergUrl}/2561`;
    this.IcebergApiTimeSeries = `${icebergUrl}/1537`;

    // GTM REMOVE
    // this.GoogleAnalyticsKey = process.env.GOOGLE_ANALYTICS_KEY;
    this.AmplitudeAPIKEY = process.env.AMPLITUDE_API_KEY;

    this.VikingEndpoint = process.env.VIKING_ENDPOINT;
    this.BrandingImageUrl = process.env.BRANDING_CDN_IMG_URL;
    this.BrandingFileUrl = process.env.BRANDING_CDN_FILE_URL;

    this.MobileIconSizes = [144, 114, 72, 57, 45];

    this.SupportedLanguages = [
      { option: 'en', des: 'English' },
      { option: 'de', des: 'Deutsch' },
      { option: 'fr', des: 'Français' },
      { option: 'ja', des: '日本語' },
      { option: 'nl', des: 'Nederlands' },
      { option: 'es', des: 'Español' },
      { option: 'it', des: 'Italiano' },
      { option: 'pt', des: 'Português' },
    ];

    this.LandingPages = [
      {
        id: 'map',
        description: gettext('Map'),
        state: 'map.equipment',
      },
      {
        id: 'assets',
        description: gettext('Asset List'),
        state: 'equipment.list',
      },
      {
        id: 'alerts',
        description: gettext('Alerts Dashboard'),
        state: 'alerts.dashboard',
      },
      {
        id: 'maintenance',
        description: gettext('Maintenance Dashboard'),
        state: 'maintenance.board',
      },
    ];
  }
}

export default new AppSettings();
